import api from '../api'

export default {
    namespaced: true,
    state: {
        networkList: {
            abroads:[],
            inlands:[]
        }
    },
    mutations: {
        setStateNetworkList(state, info) {
            Object.assign(state.networkList,info)
        }
    },
    actions: {
        getNetworkList({commit}) {
            return api.post('/nw/list','网络切换列表').then(res => {
                commit('setStateNetworkList', res.data)
            })
        },
        switchNetwork({dispatch},params){
            return api.post('/nw/switch','切换网络',params).then(()=>{
                dispatch('getNetworkList')
            })
        },
        pushInfo(store,params){
            return api.post('/nw/push','推送切换信息',params)
        }
    }
}